/**
 * Check if a dev flag is set in our query strings.
 *
 * This is only valid in the browser and is used to control certain
 * browser-specific features.
 *
 * We use the devflagk query param to add one or more flags for dev use.
 * For example: /?devflagk=profiling&devflagk=logs would set both the profiling
 * and logs flags.
 */
export const hasDevFlag = (flagName: string): boolean => {
    /**
     * We assume at this point we're running in a browser-like environment.
     * ...but let's be defensive about it.
     *
     * If we ever go DOMless on the server, we'll want to get the location
     * differently.
     *
     * NOTE: Don't access window.location like this in your code. You should
     * always be using `withLocation` to obtain a valid location unless you
     * know for certain that you shouldn't. Not sure? Then use `withLocation`.
     * Still not sure, ask FE Infra, then probably use `withLocation`.
     */
    const {search} =
        typeof window !== "undefined"
            ? // eslint-disable-next-line no-restricted-syntax -- see above
              window.location
            : {search: ""};

    const params = new URLSearchParams(search);
    const devflagk = params.getAll("devflagk");
    return devflagk.includes(flagName);
};
